var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var CalculationService = /** @class */ (function (_super) {
            __extends(CalculationService, _super);
            function CalculationService(injectedBreeze, $q, $http) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                _this.logType = "CalculationService";
                return _this;
            }
            CalculationService.prototype.getAllCalculations = function (processConfigId) {
                var systemLevelOrSpecifiedProcessConfigPredicate = new this.breezeModule.Predicate('processConfiguration_id', '==', processConfigId)
                    .or("systemLevel_id", "!=", null);
                var query = this.breezeModule.EntityQuery
                    .from("Calculations")
                    .where(systemLevelOrSpecifiedProcessConfigPredicate)
                    .orderBy("name");
                return this.executeQuery(query);
            };
            CalculationService.prototype.getAllSequenceCalculations = function (processConfigId) {
                var deferred = this.$q.defer();
                var systemLevelOrSpecifiedProcessConfigPredicate = new this.breezeModule.Predicate('processConfiguration_id', '==', processConfigId)
                    .or("systemLevel_id", "!=", null);
                var query = this.breezeModule.EntityQuery
                    .from("Calculations")
                    .where(systemLevelOrSpecifiedProcessConfigPredicate)
                    .orderBy("name");
                this.executeQuery(query).then(function (calculations) {
                    var sequenceCalculations = Enumerable.from(calculations)
                        .where(function (i) { return i.calculationType === 2 /* Sequence */; })
                        .toArray();
                    deferred.resolve(sequenceCalculations);
                });
                return deferred.promise;
            };
            CalculationService.prototype.deleteCalculation = function (calculation) {
                return this.$http.delete('./api/calculation/' + calculation.id);
            };
            CalculationService.prototype.createNewOperationParameter = function (property) {
                var operationParameter = this.createNewEntity("OperationParameter");
                operationParameter.mySchemaProperty = property;
                operationParameter.schemaProperty_id = property.id;
                return operationParameter;
            };
            CalculationService.prototype.getCalculationEagerLoadOperations = function (id) {
                var d = this.$q.defer();
                var query = this.breezeModule.EntityQuery
                    .from("CalculationExpanded")
                    .where('id', '==', id)
                    .orderBy("name");
                this.executeQuery(query).then(function (conditions) { d.resolve(conditions[0]); });
                return d.promise;
            };
            CalculationService.prototype.getCalculation = function (id) {
                return this.fetchById(id, "Calculation");
            };
            CalculationService.prototype.createNewCalculation = function () {
                var newCalculation = this.createNewEntity("Calculation");
                newCalculation.name = '';
                newCalculation.calculationType = 1 /* Standard */;
                newCalculation.uniqueIdentifier = services.UtilityService.generateGuidComb();
                return newCalculation;
            };
            CalculationService.prototype.createValueOperation = function (operator, onlyAllowListOperands) {
                var valueOperation = this.createEmptyValueOperation();
                valueOperation.onlyAllowListOperands = onlyAllowListOperands;
                this.addNewSimpleOperandToValueOperation(valueOperation);
                this.addAdditionalOperandsBeyondFirst(valueOperation, operator);
                valueOperation.operator = operator;
                services.WarsLogger.logDebug("Creating new Value Operation", this.logType);
                return valueOperation;
            };
            CalculationService.prototype.addAdditionalOperandsBeyondFirst = function (valueOperation, operator) {
                switch (operator) {
                    case 150 /* Add */:
                    case 151 /* Subtract */:
                    case 152 /* Multiply */:
                    case 153 /* Divide */:
                    case 160 /* DateTimeAdd */:
                    case 161 /* DateTimeSubtract */:
                    case 50 /* Exponent */:
                    case 51 /* Modulo */:
                    case 157 /* Min */:
                    case 158 /* Max */:
                    case 52 /* PadLeft */:
                    case 53 /* PadRight */:
                    case 159 /* Combine */:
                    case 155 /* And */:
                    case 156 /* Or */:
                    case 54 /* BooleanEvaluation */:
                    case 207 /* Join */:
                    case 251 /* Skip */:
                        this.addNewSimpleOperandToValueOperation(valueOperation);
                        break;
                    case 154 /* IfElseAssignment */:
                    case 100 /* Substring */:
                    case 101 /* ReplaceFirst */:
                    case 102 /* ReplaceAll */:
                    case 252 /* SkipTake */:
                        this.addNewSimpleOperandToValueOperation(valueOperation);
                        this.addNewSimpleOperandToValueOperation(valueOperation);
                        break;
                    case 130 /* SpreadsheetLookup */:
                        this.addNewSimpleOperandToValueOperation(valueOperation);
                        this.addNewSimpleOperandToValueOperation(valueOperation);
                        this.addNewSimpleOperandToValueOperation(valueOperation);
                        this.addNewSimpleOperandToValueOperation(valueOperation);
                        break;
                    case 10 /* Not */:
                    case 11 /* StringLength */:
                    case 1 /* SquareRoot */:
                    case 2 /* Square */:
                    case 3 /* ToLowerCase */:
                    case 4 /* ToUpperCase */:
                    case 5 /* SentenceCase */:
                    case 6 /* StartCase */:
                    case 8 /* TrimStart */:
                    case 9 /* TrimEnd */:
                    case 250 /* Distinct */:
                    case 208 /* First */:
                    case 209 /* Last */:
                        break;
                    case 200 /* Count */:
                    case 201 /* Sum */:
                    case 202 /* Average */:
                    case 203 /* MaxItem */:
                    case 204 /* MinItem */:
                    case 205 /* Any */:
                    case 206 /* All */:
                        valueOperation.onlyAllowListOperands = true;
                    default:
                        break;
                }
            };
            CalculationService.prototype.createEmptyValueOperation = function () {
                var valueOperation = this.createNewEntity("ValueOperation");
                return valueOperation;
            };
            CalculationService.prototype.addNewSimpleOperandToValueOperation = function (valueOperation) {
                var newOperand = this.createSimpleOperand(valueOperation.operands.length);
                newOperand.parentValueOperation = valueOperation;
                newOperand.parentValueOperation_id = valueOperation.id;
                valueOperation.operands.push(newOperand);
                services.WarsLogger.logDebug("Added a new Simple Operand to Value Operation", this.logType);
                return newOperand;
            };
            CalculationService.prototype.replaceOperandWithNewSimpleOperand = function (valueOperation, index) {
                // Save off existing operand;
                var oldOperand = valueOperation.operands[index];
                // Create new simple operand;
                var newOperand = this.createSimpleOperand(index);
                // Replace existing item in array with new simple operand
                valueOperation.operands.splice(index, 1, newOperand);
                newOperand.parentValueOperation = valueOperation;
                newOperand.parentValueOperation_id = valueOperation.id;
                // Tell breeze to delete old item
                this.deleteOperand(oldOperand);
                services.WarsLogger.logDebug("Replaced operand with new Simple Operand", this.logType);
                return newOperand;
            };
            CalculationService.prototype.replaceOperandWithNewComplexOperand = function (parentValueOperation, index, operator) {
                // Save off existing operand;
                var oldOperand = parentValueOperation.operands[index];
                // Create new Value Operation
                var newValueOperation = this.createValueOperation(operator, parentValueOperation.onlyAllowListOperands);
                newValueOperation.variableType = CalculationService.getValueOperationVariableType(newValueOperation);
                // Create new complex operand;
                var newOperand = this.createComplexOperand(newValueOperation, index);
                // Replace existing item in array with new simple operand
                parentValueOperation.operands.splice(index, 1, newOperand);
                // Tell breeze to delete old item
                this.deleteOperand(oldOperand);
                services.WarsLogger.logDebug("Replaced operand with new Complex Operand", this.logType);
                return newOperand;
            };
            CalculationService.prototype.createSimpleOperand = function (operandIndex) {
                var operand = this.createNewEntity("SimpleOperand");
                operand.operandType = 0 /* SimpleOperand */;
                operand.operandOrder = operandIndex;
                operand.isATimeDurationInput = false;
                services.WarsLogger.logDebug("Create new Simple Operand", this.logType);
                return operand;
            };
            CalculationService.prototype.createComplexOperand = function (valueOperation, operandIndex) {
                var complexOperand = this.createNewEntity("ComplexOperand");
                complexOperand.operandType = 1 /* ComplexOperand */;
                complexOperand.operandOrder = operandIndex;
                complexOperand.myValueOperation = valueOperation;
                complexOperand.myValueOperation_id = valueOperation.id;
                services.WarsLogger.logDebug("Create new Complex Operand", this.logType);
                return complexOperand;
            };
            CalculationService.prototype.createNewTopLevelValueOperation = function (currentTopLevelValueOperation, operator) {
                // Create new top level value operation - tie up to newly create complex operand
                var newTopLevelValueOperation = this.createEmptyValueOperation();
                newTopLevelValueOperation.onlyAllowListOperands = this.isAnAggregateOperator(operator) || this.isAListOperator(operator);
                newTopLevelValueOperation.operator = operator;
                // Create new Complex Operand and tie it to the current top level value operation
                var complexOperand = this.createNewEntity("ComplexOperand");
                complexOperand.operandType = 1 /* ComplexOperand */;
                complexOperand.operandOrder = 0;
                complexOperand.myValueOperation = currentTopLevelValueOperation;
                complexOperand.myValueOperation_id = currentTopLevelValueOperation.id;
                // Add operands to new top level value operation
                newTopLevelValueOperation.operands.push(complexOperand);
                this.addAdditionalOperandsBeyondFirst(newTopLevelValueOperation, operator);
                services.WarsLogger.logDebug("Create new top level Value Operation", this.logType);
                return newTopLevelValueOperation;
            };
            CalculationService.prototype.deleteValueOperationChildren = function (valueOperation) {
                if (valueOperation) {
                    // Go backwards because things will be disappearing from operand array once breeze setDeleteds are executed
                    for (var i = valueOperation.operands.length - 1; i >= 0; i--) {
                        var operand = valueOperation.operands[i];
                        if (operand.operandType === 0 /* SimpleOperand */) {
                            this.deleteSimpleOperand(operand);
                        }
                        else if (operand.operandType === 1 /* ComplexOperand */) {
                            this.deleteComplexOperand(operand);
                        }
                    }
                    services.WarsLogger.logDebug("Deleted Value Operation children", this.logType);
                }
            };
            CalculationService.prototype.deleteOperand = function (operand) {
                if (operand.operandType === 0 /* SimpleOperand */) {
                    this.deleteSimpleOperand(operand);
                }
                else {
                    this.deleteComplexOperand(operand);
                }
            };
            CalculationService.prototype.deleteSimpleOperand = function (simpleOperand) {
                if (simpleOperand) {
                    if (simpleOperand.treeItem) {
                        if (simpleOperand.treeItem.constantValue && this.isTypedInConstant(simpleOperand.treeItem.constantValue)) {
                            simpleOperand.treeItem.constantValue.entityAspect.setDeleted();
                        }
                        simpleOperand.treeItem.entityAspect.setDeleted();
                    }
                    simpleOperand.entityAspect.setDeleted();
                    services.WarsLogger.logDebug("Deleted Simple Operand", this.logType);
                }
            };
            CalculationService.prototype.deleteComplexOperand = function (complexOperand) {
                if (complexOperand) {
                    if (complexOperand.myValueOperation) {
                        this.deleteValueOperationChildren(complexOperand.myValueOperation);
                        complexOperand.myValueOperation.entityAspect.setDeleted();
                    }
                    complexOperand.entityAspect.setDeleted();
                    services.WarsLogger.logDebug("Deleted Complex Operand", this.logType);
                }
            };
            CalculationService.prototype.returnsAList = function (valueOperation) {
                if (!valueOperation)
                    return false;
                // Aggregate operators take list inputs and return a single value
                if (this.isAnAggregateOperator(valueOperation.operator))
                    return false;
                for (var i = 0; i < valueOperation.operands.length; i++) {
                    if (valueOperation.operands[i].operandType === 0 /* SimpleOperand */) {
                        var simpleOperand = valueOperation.operands[i];
                        if (simpleOperand && simpleOperand.treeItem && simpleOperand.treeItem.isList) {
                            return true;
                        }
                    }
                    else {
                        var complexOperand = valueOperation.operands[i];
                        if (this.returnsAList(complexOperand.myValueOperation)) {
                            return true;
                        }
                    }
                }
            };
            CalculationService.prototype.isCalculateCompleteAndValid = function (calculation) {
                var validationIssues = [];
                if (calculation.name === undefined || calculation.name === null || calculation.name.isEmptyOrSpaces())
                    validationIssues.push("Calculation Name is required.");
                if (calculation.calculationType === 2 /* Sequence */ && !this.containsSequencePlaceholder(calculation.valueOperation)) {
                    validationIssues.push("Calculation was marked as containing a sequence but no sequence placeholders (?) were found.");
                }
                if (calculation.calculationType === 3 /* NoProcess */ && this.containsProcessUsages(calculation.valueOperation)) {
                    validationIssues.push("Calculation was marked as a No Process calculation but references some process information.  Some examples of process info are " +
                        "Form Fields, Process Variable Fields, Process Initiator, Process Identifier, Current State, Current Status, and Most Recent User Action.");
                }
                validationIssues = validationIssues.concat(this.isValueOperationCompleteAndValid(calculation.valueOperation));
                return validationIssues;
            };
            CalculationService.prototype.containsProcessUsages = function (valueOperation) {
                if (!valueOperation)
                    return false;
                for (var i = 0; i < valueOperation.operands.length; i++) {
                    if (valueOperation.operands[i].operandType === 0 /* SimpleOperand */) {
                        var simpleOperand = valueOperation.operands[i];
                        if (simpleOperand && simpleOperand.treeItem &&
                            (simpleOperand.treeItem.itemSource === 6 /* FormField */ ||
                                simpleOperand.treeItem.itemSource === 10 /* Variable */)) {
                            return true;
                        }
                        if (simpleOperand && simpleOperand.treeItem && simpleOperand.treeItem.calculation &&
                            simpleOperand.treeItem.calculation.calculationType !== 3 /* NoProcess */) {
                            return true;
                        }
                        var disallowedPlaceholders = [
                            6 /* CurrentState */,
                            5 /* CurrentStatus */,
                            10 /* ProcessIdentifier */,
                            4 /* ProcessInitiator */,
                            12 /* ProcessType */,
                            11 /* UserAction */
                        ];
                        if (simpleOperand && simpleOperand.treeItem && simpleOperand.treeItem.placeholder && disallowedPlaceholders.indexOf(simpleOperand.treeItem.placeholder) !== -1) {
                            return true;
                        }
                    }
                    else {
                        var complexOperand = valueOperation.operands[i];
                        if (this.containsProcessUsages(complexOperand.myValueOperation)) {
                            return true;
                        }
                    }
                }
                return false;
            };
            CalculationService.prototype.containsSequencePlaceholder = function (valueOperation) {
                if (!valueOperation)
                    return false;
                for (var i = 0; i < valueOperation.operands.length; i++) {
                    if (valueOperation.operands[i].operandType === 0 /* SimpleOperand */) {
                        var simpleOperand = valueOperation.operands[i];
                        if (simpleOperand && simpleOperand.treeItem && simpleOperand.treeItem.constantValue &&
                            simpleOperand.treeItem.constantValue.stringValue && simpleOperand.treeItem.constantValue.stringValue.indexOf("?") !== -1) {
                            return true;
                        }
                    }
                    else {
                        var complexOperand = valueOperation.operands[i];
                        if (this.containsSequencePlaceholder(complexOperand.myValueOperation)) {
                            return true;
                        }
                    }
                }
                return false;
            };
            CalculationService.prototype.isValueOperationCompleteAndValid = function (valueOperation) {
                var validationIssues = [];
                if (!valueOperation) {
                    validationIssues.push("Cannot save an empty Calculation.  Please select the calculator icon to create your calculation or click the Cancel button.");
                    return validationIssues;
                }
                if (valueOperation.operands === undefined || valueOperation.operands.length === 0) {
                    validationIssues.push("Calculation Name is required.");
                }
                if (valueOperation.variableType == null) {
                    validationIssues.push("One of the operands contains an invalid type.");
                }
                if (valueOperation.operator === 54 /* BooleanEvaluation */) {
                    if (valueOperation.comparsionOperator === null) {
                        validationIssues.push("Comparison type not selected.");
                    }
                    else {
                        if (CalculationService.getOperandVariableType(valueOperation.operands[0]) !== CalculationService.getOperandVariableType(valueOperation.operands[1])) {
                            validationIssues.push("Attempting to compare two operands of different data types.");
                        }
                    }
                }
                for (var i = 0; i < valueOperation.operands.length; i++) {
                    validationIssues = validationIssues.concat(this.isOperandCompleteAndValid(valueOperation.operands[i]));
                }
                return validationIssues;
            };
            CalculationService.prototype.isOperandCompleteAndValid = function (operand) {
                var validationIssues = [];
                if (operand.operandType === 0 /* SimpleOperand */) {
                    validationIssues = this.isSimpleOperandCompleteAndValid(operand);
                }
                return validationIssues;
            };
            CalculationService.prototype.isSimpleOperandCompleteAndValid = function (simpleOperand) {
                var validationIssues = [];
                if (simpleOperand.treeItem) {
                    var isTypedInConstant = this.isTypedInConstant(simpleOperand.treeItem.constantValue);
                    if (isTypedInConstant) {
                        if (simpleOperand.treeItem.constantValue.decimalValue === null &&
                            simpleOperand.treeItem.constantValue.integerValue === null &&
                            simpleOperand.treeItem.constantValue.stringValue === null) {
                            validationIssues.push("An Operand is empty: No value was typed and no tree item was dragged into the operand area.");
                        }
                    }
                }
                return validationIssues;
            };
            CalculationService.prototype.isTypedInConstant = function (constantValue) {
                return constantValue != null && constantValue != undefined && constantValue.processConfiguration_id == null && constantValue.systemLevel_id == null;
            };
            CalculationService.prototype.allowAggregateOperators = function (valueOperation) {
                if (!valueOperation)
                    return true;
                // This handles going up the hierarchy
                if (valueOperation.onlyAllowListOperands)
                    return false;
                // Now we need to go down the hierarchy
                for (var i = 0; i < valueOperation.operands.length; i++) {
                    var operand = valueOperation.operands[i];
                    if (operand.operandType === 1 /* ComplexOperand */) {
                        var complexOperand = operand;
                        if (!this.allowAggregateOperators(complexOperand.myValueOperation))
                            return false;
                    }
                }
                return true;
            };
            CalculationService.prototype.allowListOperators = function (valueOperation) {
                if (!valueOperation)
                    return true;
                // TODO
                return true;
            };
            CalculationService.prototype.allowAggregateOperatorsForOperand = function (parentValueOperation, operand) {
                // This handles going up the hierarchy
                if (parentValueOperation.onlyAllowListOperands)
                    return false;
                // Now we need to go down the hierarchy
                if (operand.operandType === 1 /* ComplexOperand */) {
                    var complexOperand = operand;
                    if (!complexOperand.myValueOperation)
                        return true;
                    if (!complexOperand.myValueOperation.operands)
                        return true;
                    var childOperands = complexOperand.myValueOperation.operands;
                    for (var i = 0; i < childOperands.length; i++) {
                        var childOperand = childOperands[i];
                        if (childOperand.operandType === 1 /* ComplexOperand */) {
                            var childComplexOperand = childOperand;
                            if (!this.allowAggregateOperators(childComplexOperand.myValueOperation))
                                return false;
                        }
                    }
                }
                return true;
            };
            CalculationService.prototype.allowListOperatorsForOperand = function (parentValueOperation, operand) {
                // TODO
                return true;
            };
            CalculationService.prototype.allowOperandDelete = function (valueOperation, operandIndex) {
                if (!valueOperation || !valueOperation.operator)
                    return false;
                switch (valueOperation.operator) {
                    case 1 /* SquareRoot */:
                    case 2 /* Square */:
                    case 3 /* ToLowerCase */:
                    case 4 /* ToUpperCase */:
                    case 5 /* SentenceCase */:
                    case 6 /* StartCase */:
                    case 7 /* Value */:
                    case 8 /* TrimStart */:
                    case 9 /* TrimEnd */:
                    case 50 /* Exponent */:
                    case 51 /* Modulo */:
                    case 100 /* Substring */:
                    case 52 /* PadLeft */:
                    case 53 /* PadRight */:
                    case 101 /* ReplaceFirst */:
                    case 102 /* ReplaceAll */:
                    case 200 /* Count */:
                    case 201 /* Sum */:
                    case 202 /* Average */:
                    case 203 /* MaxItem */:
                    case 204 /* MinItem */:
                    case 205 /* Any */:
                    case 206 /* All */:
                    case 10 /* Not */:
                    case 11 /* StringLength */:
                    case 54 /* BooleanEvaluation */:
                    case 250 /* Distinct */:
                    case 207 /* Join */:
                    case 251 /* Skip */:
                    case 252 /* SkipTake */:
                    case 208 /* First */:
                    case 209 /* Last */:
                    case 130 /* SpreadsheetLookup */:
                        return false;
                    case 150 /* Add */:
                    case 151 /* Subtract */:
                    case 152 /* Multiply */:
                    case 153 /* Divide */:
                    case 160 /* DateTimeAdd */:
                    case 161 /* DateTimeSubtract */:
                    case 155 /* And */:
                    case 156 /* Or */:
                    case 157 /* Min */:
                    case 158 /* Max */:
                    case 159 /* Combine */:
                        return operandIndex >= 2;
                    case 154 /* IfElseAssignment */:
                        return operandIndex >= 3;
                    default:
                        return false;
                }
            };
            CalculationService.prototype.allowGreaterThanLessThanComparison = function (operation) {
                if (!operation)
                    return false;
                if (operation.operator !== 54 /* BooleanEvaluation */)
                    return false;
                var operand = operation.operands[0];
                if (!operand)
                    return false;
                var comparableVariableTypes = [
                    1 /* Integer */,
                    2 /* Decimal */,
                    0 /* String */,
                    4 /* Date */,
                    3 /* DateTime */,
                    5 /* Time */
                ];
                if (operand.operandType === 0 /* SimpleOperand */) {
                    var simpleOperand = operand;
                    if (!simpleOperand.treeItem)
                        return false;
                    return comparableVariableTypes.indexOf(simpleOperand.treeItem.variableType) !== -1;
                }
                else {
                    var complexOperand = operand;
                    return comparableVariableTypes.indexOf(complexOperand.myValueOperation.variableType) !== -1;
                }
            };
            CalculationService.prototype.isAnAggregateOperator = function (operator) {
                var listOperator = [
                    200 /* Count */,
                    201 /* Sum */,
                    202 /* Average */,
                    203 /* MaxItem */,
                    204 /* MinItem */,
                    205 /* Any */,
                    206 /* All */
                ];
                return listOperator.indexOf(operator) !== -1;
            };
            CalculationService.prototype.isAListOperator = function (operator) {
                var listOperator = [
                    250 /* Distinct */,
                    251 /* Skip */,
                    252 /* SkipTake */
                ];
                return listOperator.indexOf(operator) !== -1;
            };
            CalculationService.prototype.getAllowableOperandTypes = function (calculationType) {
                switch (calculationType) {
                    case 0 /* Numeric */:
                        return [
                            0 /* Numeric */,
                            4 /* Aggregate */,
                            5 /* Other */
                        ];
                    case 1 /* String */:
                        return [
                            0 /* Numeric */,
                            1 /* String */,
                            5 /* Other */
                        ];
                    case 2 /* DateTime */:
                        return [
                            2 /* DateTime */,
                            5 /* Other */
                        ];
                    case 3 /* Boolean */:
                        return [
                            1 /* String */,
                            0 /* Numeric */,
                            3 /* Boolean */,
                            4 /* Aggregate */,
                            5 /* Other */
                        ];
                    default:
                        return undefined;
                }
            };
            CalculationService.prototype.getCalculationTypeByValueOperation = function (valueOperator) {
                switch (valueOperator) {
                    case 150 /* Add */:
                    case 151 /* Subtract */:
                    case 152 /* Multiply */:
                    case 153 /* Divide */:
                    case 1 /* SquareRoot */:
                    case 2 /* Square */:
                    case 50 /* Exponent */:
                    case 157 /* Min */:
                    case 158 /* Max */:
                    case 51 /* Modulo */:
                    case 11 /* StringLength */:
                        return 0 /* Numeric */;
                    case 3 /* ToLowerCase */:
                    case 4 /* ToUpperCase */:
                    case 5 /* SentenceCase */:
                    case 6 /* StartCase */:
                    case 8 /* TrimStart */:
                    case 9 /* TrimEnd */:
                    case 52 /* PadLeft */:
                    case 53 /* PadRight */:
                    case 100 /* Substring */:
                    case 159 /* Combine */:
                    case 101 /* ReplaceFirst */:
                    case 102 /* ReplaceAll */:
                    case 130 /* SpreadsheetLookup */:
                        return 1 /* String */;
                    case 160 /* DateTimeAdd */:
                    case 161 /* DateTimeSubtract */:
                        return 2 /* DateTime */;
                    case 10 /* Not */:
                    case 155 /* And */:
                    case 156 /* Or */:
                    case 54 /* BooleanEvaluation */:
                        return 3 /* Boolean */;
                    case 200 /* Count */:
                    case 201 /* Sum */:
                    case 202 /* Average */:
                    case 203 /* MaxItem */:
                    case 204 /* MinItem */:
                    case 205 /* Any */:
                    case 206 /* All */:
                    case 207 /* Join */:
                    case 208 /* First */:
                    case 209 /* Last */:
                        return 4 /* Aggregate */;
                    case 250 /* Distinct */:
                    case 251 /* Skip */:
                    case 252 /* SkipTake */:
                        return 6 /* List */;
                    default:
                        return 5 /* Other */;
                }
            };
            CalculationService.prototype.isOperandSpecified = function (operand) {
                if (!operand)
                    return false;
                if (operand.operandType === 0 /* SimpleOperand */) {
                    var simpleOperand = operand;
                    if (simpleOperand.treeItem) {
                        var isTypedInConstant = this.isTypedInConstant(simpleOperand.treeItem.constantValue);
                        if (isTypedInConstant) {
                            if (simpleOperand.treeItem.constantValue.decimalValue === null &&
                                simpleOperand.treeItem.constantValue.integerValue === null &&
                                simpleOperand.treeItem.constantValue.stringValue === null) {
                                return false;
                            }
                        }
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    // If the operand is complex then it has been specified
                    return true;
                }
            };
            CalculationService.getOperandVariableType = function (operand) {
                if (!operand)
                    return undefined;
                if (operand.operandType === 0 /* SimpleOperand */) {
                    var simpleOperand = operand;
                    return CalculationService.getSimpleOperandVariableType(simpleOperand);
                }
                else {
                    var complexOperand = operand;
                    return CalculationService.getComplexOperandVariableType(complexOperand);
                }
            };
            CalculationService.getSimpleOperandVariableType = function (simpleOperand) {
                if (simpleOperand) {
                    if (simpleOperand.treeItem) {
                        return simpleOperand.treeItem.variableType;
                    }
                    if (simpleOperand.isATimeDurationInput) {
                        return 14 /* TimeSpan */;
                    }
                }
                return undefined;
            };
            CalculationService.getComplexOperandVariableType = function (complexOperand) {
                var variableType = undefined;
                if (complexOperand) {
                    if (complexOperand.myValueOperation) {
                        variableType = CalculationService.getValueOperationVariableType(complexOperand.myValueOperation);
                    }
                }
                return variableType;
            };
            CalculationService.getVariableTypeBasedOnOperandTypes = function (operandVariableTypes) {
                if (!operandVariableTypes)
                    return undefined;
                if (Enumerable.from(operandVariableTypes).any(function (i) { return i === undefined; }))
                    return undefined;
                var uniqueVariableTypes = Enumerable.from(operandVariableTypes).distinct();
                if (Enumerable.from(uniqueVariableTypes).all(function (i) { return i === 1 /* Integer */; }))
                    return 1 /* Integer */;
                if (Enumerable.from(uniqueVariableTypes).all(function (i) {
                    return i === 2 /* Decimal */ ||
                        i === 1 /* Integer */;
                })) {
                    return 2 /* Decimal */;
                }
                if (Enumerable.from(uniqueVariableTypes).all(function (i) { return i === 4 /* Date */; }))
                    return 4 /* Date */;
                if (Enumerable.from(uniqueVariableTypes).all(function (i) { return i === 3 /* DateTime */; }))
                    return 3 /* DateTime */;
                if (Enumerable.from(uniqueVariableTypes).all(function (i) { return i === 5 /* Time */; }))
                    return 5 /* Time */;
                if (Enumerable.from(uniqueVariableTypes).all(function (i) { return i === 24 /* Code */; }))
                    return 24 /* Code */;
                if (Enumerable.from(uniqueVariableTypes).all(function (i) { return i === 6 /* Boolean */; }))
                    return 6 /* Boolean */;
                return 0 /* String */;
            };
            CalculationService.getValueOperationVariableType = function (valueOperation) {
                if (valueOperation.operator === 10 /* Not */ ||
                    valueOperation.operator === 205 /* Any */ ||
                    valueOperation.operator === 206 /* All */ ||
                    valueOperation.operator === 155 /* And */ ||
                    valueOperation.operator === 156 /* Or */ ||
                    valueOperation.operator === 54 /* BooleanEvaluation */) {
                    return 6 /* Boolean */;
                }
                if (valueOperation.operator === 1 /* SquareRoot */ ||
                    valueOperation.operator === 2 /* Square */ ||
                    valueOperation.operator === 201 /* Sum */ ||
                    valueOperation.operator === 202 /* Average */ ||
                    valueOperation.operator === 50 /* Exponent */ ||
                    valueOperation.operator === 51 /* Modulo */ ||
                    valueOperation.operator === 150 /* Add */ ||
                    valueOperation.operator === 151 /* Subtract */ ||
                    valueOperation.operator === 152 /* Multiply */ ||
                    valueOperation.operator === 153 /* Divide */) {
                    return 2 /* Decimal */;
                }
                if (valueOperation.operator === 200 /* Count */ ||
                    valueOperation.operator === 11 /* StringLength */) {
                    return 1 /* Integer */;
                }
                if (valueOperation.operator === 3 /* ToLowerCase */ ||
                    valueOperation.operator === 4 /* ToUpperCase */ ||
                    valueOperation.operator === 5 /* SentenceCase */ ||
                    valueOperation.operator === 6 /* StartCase */ ||
                    valueOperation.operator === 8 /* TrimStart */ ||
                    valueOperation.operator === 9 /* TrimEnd */ ||
                    valueOperation.operator === 52 /* PadLeft */ ||
                    valueOperation.operator === 53 /* PadRight */ ||
                    valueOperation.operator === 100 /* Substring */ ||
                    valueOperation.operator === 101 /* ReplaceFirst */ ||
                    valueOperation.operator === 102 /* ReplaceAll */ ||
                    valueOperation.operator === 159 /* Combine */ ||
                    valueOperation.operator === 130 /* SpreadsheetLookup */ ||
                    valueOperation.operator === 207 /* Join */) {
                    return 0 /* String */;
                }
                // At this point we need to evaluate the operands
                if (!valueOperation.operands || valueOperation.operands.length === 0)
                    return undefined;
                var operandVariableTypes = [];
                for (var i = 0; i < valueOperation.operands.length; i++) {
                    if (valueOperation.operands[i]) {
                        if (valueOperation.operator === 154 /* IfElseAssignment */) {
                            if (i === 0 || (i > 2 && i % 2 === 1))
                                continue;
                        }
                        switch (valueOperation.operands[i].operandType) {
                            case 0 /* SimpleOperand */:
                                var simpleOperand = valueOperation.operands[i];
                                operandVariableTypes.push(CalculationService.getSimpleOperandVariableType(simpleOperand));
                                break;
                            case 1 /* ComplexOperand */:
                                var complexOperand = valueOperation.operands[i];
                                operandVariableTypes.push(CalculationService.getComplexOperandVariableType(complexOperand));
                                break;
                        }
                    }
                }
                var dateTimeOperands;
                var timeOperands;
                var dateOperands;
                var dateOrTimeOperands;
                if (valueOperation.operator === 160 /* DateTimeAdd */) {
                    dateTimeOperands = Enumerable.from(operandVariableTypes).count(function (i) { return i === 3 /* DateTime */; });
                    timeOperands = Enumerable.from(operandVariableTypes).count(function (i) { return i === 5 /* Time */; });
                    dateOperands = Enumerable.from(operandVariableTypes).count(function (i) { return i === 4 /* Date */; });
                    dateOrTimeOperands = dateTimeOperands + timeOperands + dateOperands;
                    if (dateOperands === 1 && timeOperands === 1)
                        return 3 /* DateTime */;
                    if (dateOrTimeOperands === 2) {
                        // Not Valid
                        return undefined;
                    }
                    if (dateOrTimeOperands === 1) {
                        return 3 /* DateTime */;
                    }
                    return 14 /* TimeSpan */;
                }
                if (valueOperation.operator === 161 /* DateTimeSubtract */) {
                    dateTimeOperands = Enumerable.from(operandVariableTypes).count(function (i) { return i === 3 /* DateTime */; });
                    timeOperands = Enumerable.from(operandVariableTypes).count(function (i) { return i === 5 /* Time */; });
                    dateOperands = Enumerable.from(operandVariableTypes).count(function (i) { return i === 4 /* Date */; });
                    dateOrTimeOperands = dateTimeOperands + timeOperands + dateOperands;
                    if (dateOperands === 1 && timeOperands === 1)
                        return 3 /* DateTime */;
                    if (dateOrTimeOperands === 2) {
                        return 14 /* TimeSpan */;
                    }
                    if (dateOrTimeOperands === 1) {
                        return 3 /* DateTime */;
                    }
                    return 14 /* TimeSpan */;
                }
                return CalculationService.getVariableTypeBasedOnOperandTypes(operandVariableTypes);
            };
            return CalculationService;
        }(services.DataService));
        services.CalculationService = CalculationService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('CalculationService', ['breeze', '$q', '$http']);
